import React, { useCallback, useEffect, useState } from 'react';
import { Checkbox, Form, Input, ColorPicker, message } from 'antd';
import { LeftArrowIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { BackButton, StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { AntDivider } from 'component/form_component/style';
import { AdminPageSizeWrap, AdminPageWrap, AdminTitleWrap } from 'pages/admin_page/style';
import {
  ColorPickerWrap,
  CreateDisplayFlex,
  CreateHeadWrap,
  CreateHeader,
  CreateLoginFormLeft,
  CreateLoginPart,
  CreatePageSubmitWrap,
  ImageUploadLoaderWrap,
  RoundUploadIcon,
  SelectedName,
  ThemeColorPickWrap,
  ThemeColorPickerIcon,
  ThemeCreatePageWrap,
} from './style';
import { useDispatch, useSelector } from 'react-redux';
import { CreateContendwrap } from 'component/create_ou_component/create_childOu_components/style';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { Upload } from 'antd';
import Loader from 'component/loader_component';
import { LoadingContainer } from 'component/table_component/antTable/loadingStyle';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { customizeTheme } from 'redux/slices/themeSlice';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { FigCaption } from 'pages/license/style';
import { debounce } from 'lodash';
import Thumbnail from '../theme_thumbnail';
import { createRoot } from 'react-dom/client';

export default function CustomizeThemes() {
  const { themeForCustomize } = useSelector((state) => state.themes);
  const [themeData, setThemeData] = useState(null);
  const [beforeLogoLoader, setBeforeLogoLoader] = useState(false);
  const [afterLogoLoader, setAfterLogoLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [beforeLogoFit, setBeforeLogoFit] = useState(false);
  const [afterLogoFit, setAfterLogoFit] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);
  const [afterLoginLogo, setAfterLoginLogo] = useState([]);
  const [beforeLoginLogo, setBeforeLoginLogo] = useState([]);
  const [favicon, setFavicon] = useState([]);
  const [backgroundImage, setBackgroundImage] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchThemeData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `/themes/${themeForCustomize.themeName}/themedata.json?_=${new Date().getTime()}`,
          {
            headers: {
              'Cache-Control': 'no-cache',
              Pragma: 'no-cache',
              Expires: '0',
            },
          }
        );
        if (!response.ok) {
          throw new Error('Failed to fetch theme data');
        }
        const data = await response.json();
        setThemeData(data);
      } catch (error) {
        return error;
      } finally {
        setLoading(false);
      }
    };

    fetchThemeData();
  }, [themeForCustomize]);

  const renameFile = (file, newName) => {
    const extension = file.name.split('.').pop();
    const newFileName = `${newName}.${extension}`;
    return new File([file], newFileName, { type: file.type });
  };

  const handleColorChange = (color, hex, field, property, propertyName) => {
    form.setFieldsValue({ [field]: { [property]: { [propertyName]: hex } } });
  };

  const debouncedHandleColorChange = useCallback(
    debounce((color, hex, field, property, propertyName) => {
      handleColorChange(color, hex, field, property, propertyName);
    }, 300),
    [handleColorChange]
  );

  useEffect(() => {
    const preventDefault = (e) => e.preventDefault();
    document.addEventListener('dragstart', preventDefault);
    document.addEventListener('selectstart', preventDefault);

    return () => {
      document.removeEventListener('dragstart', preventDefault);
      document.removeEventListener('selectstart', preventDefault);
    };
  }, []);

  const base64ToBlob = (base64, contentType) => {
    const byteCharacters = atob(base64.split(',')[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteArray = new Uint8Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteArray[i] = slice.charCodeAt(i);
      }
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  const onFinish = (values) => {
    if (!backgroundImage[0].originFileObj && !beforeLoginLogo[0].originFileObj) {
      values.images.thumbnail = themeData.images.thumbnail;
    }
    const formData = new FormData();
    formData.append('ThemeName', themeForCustomize.themeName);
    formData.append('jsonData', JSON.stringify(values));
    if (beforeLoginLogo[0].originFileObj) {
      const newBeforeLoginLogo = renameFile(beforeLoginLogo[0].originFileObj, 'Logo-BeforeLogin');
      formData.append('loginLogo', newBeforeLoginLogo);
    }
    if (afterLoginLogo[0].originFileObj) {
      const newAfterLoginLogo = renameFile(afterLoginLogo[0].originFileObj, 'Logo-AfterLogin');
      formData.append('afLoginLogo', newAfterLoginLogo);
    }
    if (favicon[0].originFileObj) {
      const newFavicon = renameFile(favicon[0].originFileObj, 'Favicon');
      formData.append('favicon', newFavicon);
    }
    if (backgroundImage[0].originFileObj) {
      const newBackgroundImage = renameFile(backgroundImage[0].originFileObj, 'backgroundImage');
      formData.append('background', newBackgroundImage);
    }

    setApiLoading(true);

    setTimeout(async () => {
      try {
        if (
          beforeLoginLogo[0].originFileObj ||
          backgroundImage[0].originFileObj ||
          values.showBackGroundImage ||
          values.colors.login.background_color ||
          values.colors.login.button_color ||
          values.colors.login.button_text_color
        ) {
          await new Promise((resolve) => {
            const div = document.createElement('div');
            div.style.width = '1920px';
            div.style.height = '1080px';
            div.style.position = 'absolute';
            div.style.top = '-3200px';
            document.body.appendChild(div);
            const root = createRoot(div);
            root.render(
              <BrowserRouter>
                <Thumbnail
                  backgroundImage={
                    backgroundImage[0].base64
                      ? backgroundImage[0].base64
                      : themeData.images.background_image + `?cache=${new Date().getTime()}`
                  }
                  logo={
                    beforeLoginLogo[0].base64
                      ? beforeLoginLogo[0].base64
                      : themeData.images.login_logo + `?cache=${new Date().getTime()}`
                  }
                  showBackImage={values.showBackGroundImage}
                  backgroundColor={values.colors.login.background_color}
                  buttonColor={values.colors.login.button_color}
                  buttonTextColor={values.colors.login.button_text_color}
                  defaultTheme={themeForCustomize?.defaultTheme}
                  onCapture={(img) => {
                    const blob = base64ToBlob(img, 'image/png');
                    formData.append('thumbnail', blob, 'thumbnail.png');
                    resolve();
                    root.unmount();
                    document.body.removeChild(div);
                  }}
                />
              </BrowserRouter>
            );
          });
        }

        const sweetAlert = await dispatch(customizeTheme(formData));
        if (sweetAlert?.payload?.status === 200) {
          await SweetSweetAlert({ sweetData: 'Theme Customized Successfully.', icon: 'success', buttonColor: 'green' });
          window.location.reload(true);
        } else {
          SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
        }
      } catch (error) {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      } finally {
        setApiLoading(false);
      }
    }, 0);
  };

  useEffect(() => {
    if (!themeForCustomize) {
      navigate('/themes');
    }
  }, [themeForCustomize]);

  useEffect(() => {
    if (themeData?.images) {
      setBackgroundImage([
        {
          status: 'done',
          url: themeData.images.background_image + `?cache=${new Date().getTime()}`,
        },
      ]);
      setFavicon([
        {
          status: 'done',
          url: themeData.images.favicon + `?cache=${new Date().getTime()}`,
        },
      ]);
      setBeforeLoginLogo([
        {
          status: 'done',
          url: themeData.images.login_logo + `?cache=${new Date().getTime()}`,
        },
      ]);
      setAfterLoginLogo([
        {
          status: 'done',
          url: themeData.images.afterlogin_logo + `?cache=${new Date().getTime()}`,
        },
      ]);
    }
    if (themeData?.colors) {
      themeData &&
        form.setFieldsValue({
          showBackGroundImage: themeData.showBackGroundImage,
          colors: {
            login: {
              ...themeData.colors.login,
            },
            afterlogin: {
              ...themeData.colors.afterlogin,
            },
            leftmenu: {
              ...themeData.colors.leftmenu,
            },
            topmenu: {
              ...themeData.colors.topmenu,
            },
            button: {
              ...themeData.colors.button,
            },
          },
          images: {
            ...themeData.images,
          },
        });
    }
  }, [themeData]);

  const handleBackgroundImage = async ({ fileList }) => {
    setLoading(true);
    if (fileList.length > 0) {
      const fileName = `backgroundImage.${fileList[0].name.split('.').pop()}`;

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      try {
        const base64Image = await toBase64(fileList[0].originFileObj);
        form.setFieldsValue({
          images: {
            background_image: `/themes/${themeForCustomize?.themeName}/${fileName}`,
            thumbnail: `/themes/${themeForCustomize?.themeName}/thumbnail.png`,
          },
        });
        await setBackgroundImage(fileList.map((file) => ({ ...file, status: 'done', base64: base64Image })));
      } catch (error) {
        return error;
      }
    }
    setLoading(false);
  };
  const checkImageDimensions = async (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const objectURL = URL.createObjectURL(file);

      img.onload = () => {
        const { width, height } = img;
        URL.revokeObjectURL(objectURL);

        if (width < 331 && height < 81) {
          resolve(true);
        } else {
          SweetSweetAlert({
            text: 'Logo width or height exceeds allowed size. Please check.',
            icon: 'info',
            buttonColor: 'blue',
          });
          resolve(false);
        }
      };

      img.onerror = () => {
        URL.revokeObjectURL(objectURL);
        message.error('Failed to load image.');
        resolve(false);
      };

      img.src = objectURL;
    });
  };

  const handleBeforeLoginLogoImage = async ({ fileList }) => {
    setBeforeLogoLoader(true);
    if (fileList.length === 0) {
      setBeforeLogoLoader(false);
      return;
    }
    const file = fileList[0];
    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    try {
      const base64Image = await toBase64(fileList[0].originFileObj);
      const fileName = `Logo-BeforeLogin.${file.name.split('.').pop()}`;
      form.setFieldsValue({
        images: {
          login_logo: `/themes/${themeForCustomize?.themeName}/${fileName}`,
          thumbnail: `/themes/${themeForCustomize?.themeName}/thumbnail.png`,
        },
      });
      setBeforeLogoFit(true);
      await setBeforeLoginLogo(fileList.map((file) => ({ ...file, status: 'done', base64: base64Image })));
      setBeforeLogoLoader(false);
    } catch (error) {
      return error;
    }
  };

  const handleAfterLoginLogoImage = async ({ fileList }) => {
    setAfterLogoLoader(true);
    if (fileList.length === 0) {
      setAfterLogoLoader(false);
      return;
    }
    try {
      const fileName = `Logo-AfterLogin.${fileList[0].name.split('.').pop()}`;
      form.setFieldsValue({
        images: { afterlogin_logo: `/themes/${themeForCustomize?.themeName}/${fileName}` },
      });
      setAfterLogoFit(true);
      await setAfterLoginLogo(fileList.map((file) => ({ ...file, status: 'done' })));

      setAfterLogoLoader(false);
    } catch (error) {
      return error;
    }
  };

  const handleFavicon = async ({ fileList }) => {
    setLoading(true);
    if (fileList.length > 0) {
      const fileName = `Favicon.${fileList[0].name.split('.').pop()}`;
      form.setFieldsValue({
        images: { favicon: `/themes/${themeForCustomize?.themeName}/${fileName}` },
      });
      await setFavicon(fileList.map((file) => ({ ...file, status: 'done' })));
    }
    setLoading(false);
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  return (
    <AdminPageWrap className='af-superadmin-customize_theme-wrap'>
      <AdminPageSizeWrap className='af-superadmin-customize_theme-content'>
        {apiLoading && <ModalOpenLoader />}
        <BackButton className='af-superadmin-customize_theme-backbutton' to='/themes'>
          <LeftArrowIcon className='af-superadmin-customize_theme-leftarrow' /> Back
        </BackButton>
        <AdminTitleWrap className='af-superadmin-customize_theme-title-wrap'>
          <h2 className='af-superadmin-customize_theme-title-head'>Customize Theme</h2>
        </AdminTitleWrap>
        <AntDivider className='af-superadmin-customize_theme-divider' plain style={{ margin: 0 }}></AntDivider>
        {loading ? (
          <LoadingContainer>
            <Loader />
          </LoadingContainer>
        ) : (
          <CreateContendwrap className='af-content-wrap af-customize_theme-content-wrap'>
            <ThemeCreatePageWrap className='af-superadmin-customize_theme-page_wrap'>
              <CreateHeadWrap className='af-superadmin-customize_theme-head-wrap'>
                <CreateHeader className='af-superadmin-customize_theme-head-wrap-name'>
                  <h3 className='af-superadmin-customize_theme-name-label'>Theme Name:</h3>
                  <SelectedName className='af-superadmin-customize_theme-name'>
                    {themeForCustomize?.themeName}
                  </SelectedName>
                </CreateHeader>
                <CreateHeader className='af-superadmin-customize_theme-head-wrap-base-name'>
                  <h3 className='af-superadmin-customize_theme-base-name-label'>Base Theme:</h3>
                  <SelectedName className='af-superadmin-customize_theme-base-name'>
                    {themeForCustomize?.baseTheme}
                  </SelectedName>
                </CreateHeader>
              </CreateHeadWrap>
              <Form
                className='af-form af-customize_theme-form'
                form={form}
                initialValues={{
                  showBackGroundImage: true,
                }}
                onFinish={onFinish}
              >
                <div className='loginTheme customize_theme-section customize_theme-section-login'>
                  <h3 className='customize_theme-section-title customize_theme-section-title-login'>Login Page:</h3>
                  <CreateLoginPart className=' customize_theme-login-part'>
                    <div className='customize_theme-before-login-wrap'>
                      <ThemeColorPickWrap className='logo customize_theme-item-wrap customize_theme-item-wrap-loginlogo'>
                        <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-loginlogo'>
                          <Form.Item
                            className='af-customize_theme-form-item af-customize_theme-form-item-login-logo'
                            name={['images', 'login_logo']}
                            label='Logo :'
                          >
                            {beforeLogoLoader ? (
                              <ImageUploadLoaderWrap>
                                <Loader />
                              </ImageUploadLoaderWrap>
                            ) : (
                              <Upload
                                accept='.png, .jpg, .jpeg'
                                maxCount={1}
                                listType='picture-card'
                                fileList={beforeLoginLogo}
                                onChange={handleBeforeLoginLogoImage}
                                className={`${
                                  beforeLogoFit ? 'object-fit-none' : 'object-fit-fill'
                                } af-form-upload af-customize_theme-form-upload af-customize_theme-form-upload_login-logo`}
                                onPreview={onPreview}
                                beforeUpload={async (file) => {
                                  const isValid = await checkImageDimensions(file);
                                  return isValid || Upload.LIST_IGNORE;
                                }}
                              >
                                <RoundUploadIcon className='af-customize_theme-upload-button af-customize_theme-upload-button-loginlogo' />
                              </Upload>
                            )}
                          </Form.Item>
                          <FigCaption className='logoinfo customize_theme-form-caption'>
                            Width: 330px max, Height: 80px max
                          </FigCaption>
                        </div>
                      </ThemeColorPickWrap>
                      <CreateLoginFormLeft className='customize_theme-item-wrap-loginlogo-colorpick-wrap'>
                        <ThemeColorPickWrap className='customize_theme-item-wrap customize_theme-item-wrap-login-background_color'>
                          <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-login-background_color'>
                            <Form.Item
                              className='af-customize_theme-form-item af-customize_theme-form-item-login-background_color'
                              name={['colors', 'login', 'background_color']}
                              label='Background Color:'
                            >
                              <Input className='af-customize_theme-form-input af-customize_theme-form-input_background_color' />
                            </Form.Item>
                          </div>
                          <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-login-background_color'>
                            <ColorPicker
                              defaultValue={themeData?.colors.login.background_color}
                              className='customize_theme-colorpicker customize_theme-colorpicker-login-background_color'
                              onChange={(color, hex) =>
                                debouncedHandleColorChange(color, hex, 'colors', 'login', 'background_color')
                              }
                            >
                              <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-login-background_color' />
                            </ColorPicker>
                          </ColorPickerWrap>
                        </ThemeColorPickWrap>
                        <ThemeColorPickWrap className='customize_theme-item-wrap customize_theme-item-wrap-login-button_color'>
                          <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-login-button_color'>
                            <Form.Item
                              className='af-customize_theme-form-item af-customize_theme-form-item-login-button_color'
                              name={['colors', 'login', 'button_color']}
                              label='Button Color:'
                            >
                              <Input className='af-customize_theme-form-input af-customize_theme-form-input_login_button_color' />
                            </Form.Item>
                          </div>
                          <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-login-button_color'>
                            <ColorPicker
                              defaultValue={themeData?.colors.login.button_color}
                              className='customize_theme-colorpicker customize_theme-colorpicker-login-button_color'
                              onChange={(color, hex) =>
                                debouncedHandleColorChange(color, hex, 'colors', 'login', 'button_color')
                              }
                            >
                              <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-login-button_color' />
                            </ColorPicker>
                          </ColorPickerWrap>
                        </ThemeColorPickWrap>
                        <ThemeColorPickWrap className='customize_theme-item-wrap customize_theme-item-wrap-login-button_text_color'>
                          <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-login-button_text_color'>
                            <Form.Item
                              className='af-customize_theme-form-item af-customize_theme-form-item-login-button_text_color'
                              name={['colors', 'login', 'button_text_color']}
                              label='Button Text Color:'
                            >
                              <Input className='af-customize_theme-form-input af-customize_theme-form-input_login_button_text_color' />
                            </Form.Item>
                          </div>
                          <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-login_button_text_color'>
                            <ColorPicker
                              defaultValue={themeData?.colors.login.button_text_color}
                              className='customize_theme-colorpicker customize_theme-colorpicker-login_button_text_color'
                              onChange={(color, hex) =>
                                debouncedHandleColorChange(color, hex, 'colors', 'login', 'button_text_color')
                              }
                            >
                              <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-login-button_text_color' />
                            </ColorPicker>
                          </ColorPickerWrap>
                        </ThemeColorPickWrap>
                      </CreateLoginFormLeft>
                    </div>
                    <div className='customize_theme-fav-bg-wrap'>
                      <ThemeColorPickWrap className='favicon customize_theme-item-wrap customize_theme-item-wrap-favicon'>
                        <Form.Item
                          className='af-customize_theme-form-item af-customize_theme-form-item-favicon'
                          name={['images', 'favicon']}
                          label='Fav Icon :'
                        >
                          <Upload
                            maxCount={1}
                            listType='picture-card'
                            fileList={favicon}
                            onChange={handleFavicon}
                            onPreview={onPreview}
                            beforeUpload={() => false}
                            className='af-form-upload af-customize_theme-form-upload af-customize_theme-form-upload_favicon'
                          >
                            <RoundUploadIcon className='af-customize_theme-upload-button af-customize_theme-upload-button-favicon' />
                          </Upload>
                        </Form.Item>
                      </ThemeColorPickWrap>
                      <ThemeColorPickWrap className='backgroundimage customize_theme-item-wrap customize_theme-item-wrap-background_image'>
                        <Form.Item
                          className='af-customize_theme-form-item af-customize_theme-form-item-background_image'
                          name='showBackGroundImage'
                          label='Background Image:'
                          valuePropName='checked'
                        >
                          <Checkbox
                            className='af-form-checkbox af-customize_theme-form-checkbox af-customize_theme-form-checkbox_background_image'
                            checked={true}
                            style={{ marginLeft: '10px' }}
                          />
                        </Form.Item>

                        <div
                          style={{ marginLeft: '10px' }}
                          className='af-customize_theme-item-wrap af-customize_theme-item-wrap-background_image'
                        >
                          <Form.Item
                            name={['images', 'background_image']}
                            className='af-customize_theme-form-item af-customize_theme-form-item-background_image'
                          >
                            <Upload
                              maxCount={1}
                              listType='picture-card'
                              fileList={backgroundImage}
                              onChange={handleBackgroundImage}
                              onPreview={onPreview}
                              beforeUpload={() => false}
                              className='af-form-upload af-customize_theme-form-upload af-customize_theme-form-upload_background_image'
                            >
                              <RoundUploadIcon className='af-customize_theme-upload-button af-customize_theme-upload-button-background_image' />
                            </Upload>
                          </Form.Item>
                        </div>
                      </ThemeColorPickWrap>
                      {/* Thumbnail is hideen it's only used for form data */}
                      <ThemeColorPickWrap
                        className='customize_theme-item-wrap customize_theme-item-wrap-thumbnail'
                        style={{ display: 'none' }}
                      >
                        <Form.Item
                          className='af-customize_theme-form-item af-customize_theme-form-item-thumbnail'
                          name={['images', 'thumbnail']}
                        ></Form.Item>
                      </ThemeColorPickWrap>
                    </div>
                  </CreateLoginPart>
                </div>
                <div className='customize_theme-section customize_theme-section-after-login'>
                  <h3 className=' customize_theme-login-section-title customize_theme-section-title-after-login'>
                    After Login:
                  </h3>
                  <CreateDisplayFlex
                    className='customize_theme-flex-wrap customize_theme-flex-wrap-after-login'
                    style={{ maxWidth: '50rem' }}
                  >
                    <ThemeColorPickWrap className='logo customize_theme-item-wrap customize_theme-item-wrap-afterlogin_logo'>
                      <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-afterlogin_logo'>
                        <Form.Item
                          className='af-customize_theme-form-item af-customize_theme-form-item-afterlogin_logo'
                          name={['images', 'afterlogin_logo']}
                          label='Logo :'
                        >
                          {afterLogoLoader ? (
                            <ImageUploadLoaderWrap>
                              <Loader />
                            </ImageUploadLoaderWrap>
                          ) : (
                            <Upload
                              accept='.png, .jpg, .jpeg'
                              maxCount={1}
                              listType='picture-card'
                              fileList={afterLoginLogo}
                              onChange={handleAfterLoginLogoImage}
                              onPreview={onPreview}
                              className={`${
                                afterLogoFit ? 'object-fit-none' : 'object-fit-fill'
                              } af-form-upload af-customize_theme-form-upload af-customize_theme-form-upload_afterlogin_logo`}
                              beforeUpload={async (file) => {
                                const isValid = await checkImageDimensions(file);
                                return isValid || Upload.LIST_IGNORE;
                              }}
                            >
                              <RoundUploadIcon className='af-customize_theme-upload-button af-customize_theme-upload-button-afterlogin_logo' />
                            </Upload>
                          )}
                        </Form.Item>
                        <FigCaption className='logoinfo customize_theme-form-caption'>
                          Width: 330px max, Height: 80px max
                        </FigCaption>
                      </div>
                    </ThemeColorPickWrap>

                    <ThemeColorPickWrap className='logo customize_theme-item-wrap customize_theme-item-wrap-afterlogin-background_color'>
                      <Form.Item
                        className='af-customize_theme-form-item af-customize_theme-form-item-afterlogin-background_color'
                        name={['colors', 'afterlogin', 'background_color']}
                        label='Background:'
                      >
                        <Input className='af-customize_theme-form-input af-customize_theme-form-input-afterlogin_background_color' />
                      </Form.Item>

                      <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-button-afterlogin_background_color'>
                        <ColorPicker
                          defaultValue={themeData?.colors.afterlogin.background_color}
                          className='customize_theme-colorpicker customize_theme-colorpicker-button-afterlogin_background_color'
                          onChange={(color, hex) =>
                            debouncedHandleColorChange(color, hex, 'colors', 'afterlogin', 'background_color')
                          }
                        >
                          <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-button-afterlogin_background_color' />
                        </ColorPicker>
                      </ColorPickerWrap>
                    </ThemeColorPickWrap>
                  </CreateDisplayFlex>
                </div>
                <div className='customize_theme-section customize_theme-section-left_menu'>
                  <h4 className=' customize_theme-section-title customize_theme-section-title-left_menu'>Left Menu:</h4>
                  <CreateDisplayFlex className='customize_theme-flex-wrap customize_theme-flex-wrap-left-menu'>
                    <div className='customize_theme-item-wrap-outer customize_theme-item-wrap-outer-leftmenu-panel_color'>
                      <ThemeColorPickWrap className='customize_theme-item-wrap customize_theme-item-wrap-leftmenu-panel_color'>
                        <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-leftmenu-panel_color'>
                          <Form.Item
                            className='af-customize_theme-form-item af-customize_theme-form-item-leftmenu-panel_color'
                            name={['colors', 'leftmenu', 'panel_color']}
                            label='Panel:'
                          >
                            <Input className='af-customize_theme-form-input af-customize_theme-form-input-leftmenu_panel_color' />
                          </Form.Item>
                        </div>
                        <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-button-leftmenu_panel_color'>
                          <ColorPicker
                            defaultValue={themeData?.colors.leftmenu.panel_color}
                            className='customize_theme-colorpicker customize_theme-colorpicker-button-leftmenu_panel_color'
                            onChange={(color, hex) =>
                              debouncedHandleColorChange(color, hex, 'colors', 'leftmenu', 'panel_color')
                            }
                          >
                            <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-button-leftmenu_panel_color' />
                          </ColorPicker>
                        </ColorPickerWrap>
                      </ThemeColorPickWrap>
                    </div>

                    <ThemeColorPickWrap className='customize_theme-item-wrap customize_theme-item-wrap-leftmenu-text_color'>
                      <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-leftmenu-text_color'>
                        <Form.Item
                          className='af-customize_theme-form-item af-customize_theme-form-item-leftmenu-text_color'
                          name={['colors', 'leftmenu', 'text_color']}
                          label='Text:'
                        >
                          <Input className='af-customize_theme-form-input af-customize_theme-form-input-leftmenu_text_color' />
                        </Form.Item>
                      </div>
                      <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-button-leftmenu_text_color'>
                        <ColorPicker
                          defaultValue={themeData?.colors.leftmenu.text_color}
                          className='customize_theme-colorpicker customize_theme-colorpicker-button-leftmenu_text_color'
                          onChange={(color, hex) =>
                            debouncedHandleColorChange(color, hex, 'colors', 'leftmenu', 'text_color')
                          }
                        >
                          <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-button-leftmenu_text_color' />
                        </ColorPicker>
                      </ColorPickerWrap>
                    </ThemeColorPickWrap>

                    <ThemeColorPickWrap className='customize_theme-item-wrap customize_theme-item-wrap-leftmenu-active_color'>
                      <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-leftmenu-active_color'>
                        <Form.Item
                          className='af-customize_theme-form-item af-customize_theme-form-item-leftmenu-active_color'
                          name={['colors', 'leftmenu', 'active_color']}
                          label='Active:'
                        >
                          <Input className='af-customize_theme-form-input af-customize_theme-form-input-leftmenu_active_color' />
                        </Form.Item>
                      </div>
                      <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-button-leftmenu_active_color'>
                        <ColorPicker
                          defaultValue={themeData?.colors.leftmenu.active_color}
                          className='customize_theme-colorpicker customize_theme-colorpicker-button-leftmenu_active_color'
                          onChange={(color, hex) =>
                            debouncedHandleColorChange(color, hex, 'colors', 'leftmenu', 'active_color')
                          }
                        >
                          <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-button-leftmenu_active_color' />
                        </ColorPicker>
                      </ColorPickerWrap>
                    </ThemeColorPickWrap>

                    <ThemeColorPickWrap className='customize_theme-item-wrap customize_theme-item-wrap-leftmenu_highlighter_color'>
                      <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-leftmenu_highlighter_color'>
                        <Form.Item
                          className='af-customize_theme-form-item af-customize_theme-form-item--leftmenuhighlighter_color'
                          name={['colors', 'leftmenu', 'highlighter_color']}
                          label='Highlighter:'
                        >
                          <Input className='af-customize_theme-form-input af-customize_theme-form-input-leftmenu_highlighter_color' />
                        </Form.Item>
                      </div>
                      <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-button-leftmenu_highlighter_color'>
                        <ColorPicker
                          defaultValue={themeData?.colors.leftmenu.highlighter_color}
                          className='customize_theme-colorpicker customize_theme-colorpicker-button-leftmenu_highlighter_color'
                          onChange={(color, hex) =>
                            debouncedHandleColorChange(color, hex, 'colors', 'leftmenu', 'highlighter_color')
                          }
                        >
                          <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-button-leftmenu_text_color' />
                        </ColorPicker>
                      </ColorPickerWrap>
                    </ThemeColorPickWrap>
                  </CreateDisplayFlex>
                </div>
                <div className='customize_theme-section customize_theme-section-top_menu'>
                  <h4 className=' customize_theme-section-title customize_theme-section-title-top_menu'>Top Menu:</h4>
                  <CreateDisplayFlex className='customize_theme-flex-wrap customize_theme-flex-wrap-top-menu'>
                    <ThemeColorPickWrap className='customize_theme-item-wrap customize_theme-item-wrap-topmenu_text_color'>
                      <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-topmenu_text_color'>
                        <Form.Item
                          className='af-customize_theme-form-item af-customize_theme-form-item-topmenu-text_color'
                          name={['colors', 'topmenu', 'text_color']}
                          label='Text:'
                        >
                          <Input className='af-customize_theme-form-input af-customize_theme-form-input_topmenu_text_color' />
                        </Form.Item>
                      </div>
                      <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-button_topmenu_text_color'>
                        <ColorPicker
                          defaultValue={themeData?.colors.topmenu.text_color}
                          className='customize_theme-colorpicker customize_theme-colorpicker-button_topmenu_text_color'
                          onChange={(color, hex) =>
                            debouncedHandleColorChange(color, hex, 'colors', 'topmenu', 'text_color')
                          }
                        >
                          <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-button-topmenu_text_color' />
                        </ColorPicker>
                      </ColorPickerWrap>
                    </ThemeColorPickWrap>
                    <div className='customize_theme-item-wrap-outer customize_theme-item-wrap-outer-topmenu-hover_color'>
                      <ThemeColorPickWrap className='customize_theme-item-wrap customize_theme-item-wrap-topmenu_hover_color'>
                        <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-topmenu_hover_color'>
                          <Form.Item
                            className='af-customize_theme-form-item af-customize_theme-form-item-topmenu_hover_color'
                            name={['colors', 'topmenu', 'hover_color']}
                            label='Hover:'
                          >
                            <Input className='af-customize_theme-form-input af-customize_theme-form-input_topmenu_hover_color' />
                          </Form.Item>
                        </div>
                        <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-button_topmenu_hover_color'>
                          <ColorPicker
                            defaultValue={themeData?.colors.topmenu.hover_color}
                            className='customize_theme-colorpicker customize_theme-colorpicker-button_topmenu_hover_color'
                            onChange={(color, hex) =>
                              debouncedHandleColorChange(color, hex, 'colors', 'topmenu', 'hover_color')
                            }
                          >
                            <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-button-topmenu_hover_color' />
                          </ColorPicker>
                        </ColorPickerWrap>
                      </ThemeColorPickWrap>
                    </div>

                    <ThemeColorPickWrap className='customize_theme-item-wrap customize_theme-item-wrap-topmenu_active_color'>
                      <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-topmenu_active_color'>
                        <Form.Item
                          className='af-customize_theme-form-item af-customize_theme-form-item-topmenu_active_color'
                          name={['colors', 'topmenu', 'active_color']}
                          label='Active:'
                        >
                          <Input className='af-customize_theme-form-input af-customize_theme-form-input_topmenu_active_color' />
                        </Form.Item>
                      </div>
                      <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-button_topmenu_active_color'>
                        <ColorPicker
                          defaultValue={themeData?.colors.topmenu.active_color}
                          className='customize_theme-colorpicker customize_theme-colorpicker-button_topmenu_active_color'
                          onChange={(color, hex) =>
                            debouncedHandleColorChange(color, hex, 'colors', 'topmenu', 'active_color')
                          }
                        >
                          <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-button-topmenu_active_color' />
                        </ColorPicker>
                      </ColorPickerWrap>
                    </ThemeColorPickWrap>

                    <ThemeColorPickWrap className='customize_theme-item-wrap customize_theme-item-wrap-topmenu_highlighter_color'>
                      <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-topmenu_highlighter_color'>
                        <Form.Item
                          className='af-customize_theme-form-item af-customize_theme-form-item-topmenu_highlighter_color'
                          name={['colors', 'topmenu', 'highlighter_color']}
                          label='Highlighter:'
                        >
                          <Input className='af-customize_theme-form-input af-customize_theme-form-input_topmenu_highlighter_color' />
                        </Form.Item>
                      </div>
                      <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-button_topmenu_highlighter_color'>
                        <ColorPicker
                          defaultValue={themeData?.colors.topmenu.highlighter_color}
                          className='customize_theme-colorpicker customize_theme-colorpicker-button_topmenu_highlighter_color'
                          onChange={(color, hex) =>
                            debouncedHandleColorChange(color, hex, 'colors', 'topmenu', 'highlighter_color')
                          }
                        >
                          <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-button-topmenu_highlighter_color' />
                        </ColorPicker>
                      </ColorPickerWrap>
                    </ThemeColorPickWrap>
                  </CreateDisplayFlex>
                </div>
                <div className='customize_theme-section customize_theme-section-button'>
                  <h4 className=' customize_theme-section-title customize_theme-section-title-button'>Button:</h4>
                  <CreateDisplayFlex
                    className='customize_theme-flex-wrap customize_theme-flex-wrap-button'
                    style={{ maxWidth: '70rem' }}
                  >
                    <div className='customize_theme-item-wrap-outer customize_theme-item-wrap-outer-button_default_color'>
                      <ThemeColorPickWrap className='customize_theme-item-wrap customize_theme-item-wrap-button_default_color'>
                        <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-button_default_color'>
                          <Form.Item
                            className='af-customize_theme-form-item af-customize_theme-form-item-button_default_color'
                            name={['colors', 'button', 'default_color']}
                            label='Default:'
                          >
                            <Input className='af-customize_theme-form-input af-customize_theme-form-input_button_default_color' />
                          </Form.Item>
                        </div>
                        <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-button_button_default_color'>
                          <ColorPicker
                            defaultValue={themeData?.colors.button.default_color}
                            className='customize_theme-colorpicker customize_theme-colorpicker-button_button_default_color'
                            onChange={(color, hex) =>
                              debouncedHandleColorChange(color, hex, 'colors', 'button', 'default_color')
                            }
                          >
                            <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-button-button_default_color' />
                          </ColorPicker>
                        </ColorPickerWrap>
                      </ThemeColorPickWrap>
                    </div>

                    <ThemeColorPickWrap className='customize_theme-item-wrap customize_theme-item-wrap-button_text_color'>
                      <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-button_text_color'>
                        <Form.Item
                          className='af-customize_theme-form-item af-customize_theme-form-item-button_button_text_color'
                          name={['colors', 'button', 'text_color']}
                          label='Text:'
                        >
                          <Input className='af-customize_theme-form-input af-customize_theme-form-input_button_button_text_color' />
                        </Form.Item>
                      </div>
                      <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-button_button_button_text_color'>
                        <ColorPicker
                          defaultValue={themeData?.colors.button.text_color}
                          className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-button_button_button_text_color'
                          onChange={(color, hex) =>
                            debouncedHandleColorChange(color, hex, 'colors', 'button', 'text_color')
                          }
                        >
                          <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-button-button_text_color' />
                        </ColorPicker>
                      </ColorPickerWrap>
                    </ThemeColorPickWrap>

                    <ThemeColorPickWrap className='customize_theme-item-wrap customize_theme-item-wrap-button_hover_color'>
                      <div className='customize_theme-item-inner-wrap customize_theme-item-wrap-inner-button_hover_color'>
                        <Form.Item
                          className='af-customize_theme-form-item af-customize_theme-form-item-button_button_text_color'
                          name={['colors', 'button', 'hover_color']}
                          label='Hover:'
                        >
                          <Input className='af-customize_theme-form-input af-customize_theme-form-input-button_text_color' />
                        </Form.Item>
                      </div>
                      <ColorPickerWrap className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-button-button_text_color'>
                        <ColorPicker
                          defaultValue={themeData?.colors.button.hover_color}
                          className='customize_theme-colorpicker-wrap customize_theme-colorpicker-wrap-button-button_text_color'
                          onChange={(color, hex) =>
                            debouncedHandleColorChange(color, hex, 'colors', 'button', 'hover_color')
                          }
                        >
                          <ThemeColorPickerIcon className='customize_theme-colorpicker-icon customize_theme-colorpicker-iocn-button-button_hover_color' />
                        </ColorPicker>
                      </ColorPickerWrap>
                    </ThemeColorPickWrap>
                  </CreateDisplayFlex>
                </div>
                <CreatePageSubmitWrap className='af-form-button-submit-wrapper af-customize_theme-form-button-submit-wrapper'>
                  <Form.Item className='af-customize_theme-form-item af-customize_theme-form-item-submitbutton'>
                    <StyledButton
                      className='af-form-button af-customize_theme-form-button af-customize_theme-form-button_submit'
                      type='primary'
                      htmlType='submit'
                      style={{ margin: 0, width: '150px' }}
                    >
                      Save
                    </StyledButton>
                  </Form.Item>
                </CreatePageSubmitWrap>
              </Form>
            </ThemeCreatePageWrap>
          </CreateContendwrap>
        )}
      </AdminPageSizeWrap>
    </AdminPageWrap>
  );
}
